import api from "../config/ApiConfig";

const npsService = {
  /**
   * Record NPS score
   * @param {string} token - NPS token
   * @param {number} score - Score (1-10)
   * @returns {Promise}
   */
  async recordScore(token, score) {
    const response = await api.get(`/nps/${token}/rate/${score}`);
    return response;
  },

  /**
   * Submit optional comment
   * @param {string} token - NPS token
   * @param {string} comment - User comment
   * @returns {Promise}
   */
  async submitComment(token, comment) {
    const response = await api.post(`/nps/${token}/comment`, {
      feedback_text: comment
    });
    return response;
  }
};

export default npsService;
